import { toFarsiNumber } from "@utils/digits";
import { FESTIVAL_TYPE } from "../../types";

export const festivalTexts = {
  [FESTIVAL_TYPE.PERCENT]: (discountText: string) => (
    <p>
      در این طرح شما می‌توانید هر کدام از آموزش‌های مورد نظر خود را با
      <span className="text-[#F9D854] text-base leading-6 xsm:leading-7 mx-1">
        {toFarsiNumber(discountText)} درصد
      </span>
      تخفیف ویژه دریافت کنید.
    </p>
  ),
  [FESTIVAL_TYPE.WONDER]: (
    discountText: string,
    specialText: string,
    title: string
  ) => (
    <>
      <p>
        با
        <span className="text-[#F9D854] inline-block text-base leading-6 xsm:leading-7 mx-1">
          {toFarsiNumber(discountText)} هزار تومان
        </span>
        هر چی میخوای یاد بگیر!
      </p>
      <p>
        <span className="text-[#F9D854] text-base leading-6 xsm:leading-7 mx-1">
          {toFarsiNumber(specialText)}
        </span>{" "}
        فرادرس در <span>{toFarsiNumber(title)}</span>!
      </p>
    </>
  ),
  [FESTIVAL_TYPE.STEPPED_AMOUNT]: () => <></>,
  [FESTIVAL_TYPE.STEPPED_COUNT]: () => <></>,
};
